<template>
    <div class="container-fluid">
        <div class="container-fluid">
            <div class="row mb-1">
                <div class="col-xxl-3 col-lg-4 col-sm-6 text-start pb-1">
                    <span class="badge rounded-pill bg-success pull-left mt-1 py-2 px-4" style="font-size:18px; background:white">
                        <b>Lab Result Print : พิมพ์ผลแล็บ</b>
                    </span>
                </div>
                <div class="col-xxl col-lg col-sm-6 text-start">
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่รับเข้าห้องแล็บ">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model="status1Lab">
                      <label class="form-check-label" for="inlineCheckbox1"><b>Lab</b> </label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="2" v-model="status2Res">
                      <label class="form-check-label" for="inlineCheckbox2"><b>Resulted</b> </label>
                    </div>
                    <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="3" v-model="status3App">
                      <label class="form-check-label" for="inlineCheckbox3"><b>AP</b> </label>
                    </div>
                </div>
                <!-- Toggle : พาเนลตัวเลือก พิมพ์ฟอร์มผลแล็บ -->
                <div class="col-xxl-2 col-lg-3 col-sm-6 text-start">
                  <div class="form-check form-switch mt-2 ms-5" title="แสดงตัวเลือกปรับแต่ง รูปแบบใบผลแล็บ">
                    <input class="form-check-input" type="checkbox" id="condPrintOption" name="darkmode"
                      value="true" v-model="condPrintOption">
                    <label class="form-check-label" for="condPrintOption">ปรับรูปแบบใบผลแล็บ</label>
                  </div>
                </div>
            </div>
            <!-- Print Option : Checkbox / Dropdown / Radio -->
            <div class="row mb-1 bg-info" v-show="condPrintOption"  title="ตัวเลือกสำหรับการพิมพ์ผลตรวจออกเครื่องพิมพ์">
                <div class="col-lg-2 col-md-6">
                    <!-- ชื่อคนไข้ที่หนึ่ง หรือชื่อที่สอง(EN) -->
                    <div class="input-group input-group-sm mb-1">
                        <span class="input-group-text mt-1" style="width:120px; font-size:80%;">ชื่อคนไข้ที่พิมพ์ :</span>
                        <select class="form-select form-select-sm mt-1" style="font-size:80%;"
                          ref="nameIdx" id="nameIdx" name="nameIdx" v-model="nameIdx" >
                            <option :value="1" selected >ชื่อหลัก (TH)</option>
                            <option :value="2">ชื่อที่สอง (EN)</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6">
                    <!-- ชื่อชุดตรวจที่หนึ่ง หรือชื่อที่สอง -->
                    <div class="input-group input-group-sm">
                        <span class="input-group-text mt-1" style="width:120px; font-size:80%;">ชื่อชุดตรวจพิมพ์ :</span>
                        <select class="form-select form-select-sm mt-1" style="font-size:80%;"
                          ref="nameTestsuitIdx" id="nameTestsuitIdx" name="nameTestsuitIdx" v-model="nameTestsuitIdx" >
                            <option :value="0" selected>ชื่อชุดตรวจหลัก</option>
                            <option :value="1">ชื่อชุดตรวจที่สอง</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg col-md text-start" style="font-size:90%;">
                    <div class="form-check form-check-inline mx-3 pt-2" title="พิมพ์ผลแล็บเฉพาะที่ป้อนผลแล้ว ที่ยังไม่มีข้อมูลจะไม่ถูกพิมพ์">
                      <input class="form-check-input" type="checkbox" style="width:16px;height:16px;" id="optResultedOnly" value="0" v-model="optResultedOnly">
                      <label class="form-check-label" for="optResultedOnly">พิมพ์ผลแล็บเฉพาะที่ป้อนผลแล้ว </label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="พิมพ์ข้อมูลวันเกิดของคนไข้">
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optDOB" value="0" v-model="optDOB">
                      <label class="form-check-label" for="optDOB">พิมพ์ข้อมูลวันเกิด </label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงลายน้ำชื่อคลินิก">
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optWatermark" value="0" v-model="optWatermark">
                      <label class="form-check-label" for="optWatermark">แสดงลายน้ำชื่อคลินิก</label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="พิมพ์หน้าละหนึ่งชุดเทสตรวจ" hidden>
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optOneTestsuitPerPaper" value="0" v-model="optOneTestsuitPerPaper">
                      <label class="form-check-label" for="optOneTestsuitPerPaper">(พิมพ์แยกหน้าละหนึ่งชุดเทสตรวจ)</label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="ตารางแบบมีเส้นบรรทัด" >
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optHLineTable" value="0" v-model="optHLineTable">
                      <label class="form-check-label" for="optHLineTable">ตารางแบบมีเส้นบรรทัด</label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงชื่อห้องตรวจ">
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optRoomShow" value="0" v-model="optRoomShow">
                      <label class="form-check-label" for="optRoomShow">แสดงชื่อห้องตรวจ</label>
                    </div>
                    <span> | </span>
                    <div class="form-check form-check-inline mx-3 pt-2" title="เลือกถ้าต้องการขึ้นหน้าใหม่เมื่อเปลี่ยนห้องตรวจ (ปกติจะพิมพ์ต่อเนื่องในหน้าเดียวกัน)">
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optRoomSplit" value="0" v-model="optRoomSplit" :disabled="optTSSplit == 1">
                      <label class="form-check-label" for="optRoomSplit">พิมพ์แยกห้องตรวจ</label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="เลือกถ้าต้องการขึ้นหน้าใหม่ในแต่ละชุดตรวจ">
                      <input class="form-check-input" type="checkbox"  style="width:16px;height:16px;" id="optTSSplit" value="0" v-model="optTSSplit" :disabled="optRoomSplit == 1">
                      <label class="form-check-label" for="optTSSplit">พิมพ์แยกชุดตรวจ</label>
                    </div>
                </div>
            </div>
            <!-- <hr style="height:2px;border-width:0;color:black;background-color:black;"> -->
            <div class="row py-2 border border-2" style="background-color:LightGrey;">
                <div class="col-sm">
                    <!-- DEFAULT : (1.) ดึงข้อมูลจาก [ช่วงวันที่] -->
                    <div class="row">
                        <div class="col-sm-12 col-md-5 col-lg-3 col-xl-4">
                          <!-- สาขาแล็บ -->
                          <div class="input-group input-group-sm">
                              <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">สาขา* :</span>
                              </div>
                              <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID" >
                                  <option disabled value="">Please select one</option>
                                  <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                              </select>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-7 col-lg-9 col-xl-8">
                          <!-- วันที่ใบสั่งตรวจ -->
                          <div class="input-group input-group-sm mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                            </div>
                            <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateFm" ref="dateFm" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateTo" ref="dateTo" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                            <!-- Toggle : ต้องการดึงข้อมูลระบุคนไข้/คลินิก -->
                            <div class="form-check form-switch mt-1 ms-5">
                              <input class="form-check-input" type="checkbox" id="condSearchPatient" name="darkmode" @click="resetCondSearch()"
                               value="true" v-model="condSearchPatient">
                              <label class="form-check-label" for="condSearchPatient">กรองข้อมูลโดยระบุคนไข้หรือคลินิก</label>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- (2) เพิ่มเงื่อนไข ดึงข้อมูลของคนไข้ที่ระบุ [PatID]  -->
                    <div class="row" v-show="condSearchPatient" >
                      <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                        <!-- ระบุคนไข้ : ชื่อ / นามสกุล -->
                        <div class="input-group input-group-sm mb-1" title="เพิ่มเงื่อนไข ดึงข้อมูลพิมพ์ผลแล็บเฉพาะของคนไข้ที่ระบุ .. กดปุ่ม <ค้นหา> เพื่อเลือกคนไข้">
                            <div class="input-group-prepend">
                            <span class="input-group-text" style="width:120px;">ชื่อคนไข้ :</span>
                            </div>
                            <input type="text" class="form-control form-control-sm bg-warning" ref="condPatID" name="condPatID" v-model="condPatID" readonly hidden>
                            <input type="text" class="form-control form-control-sm" style="background-color:Linen;" ref="condPatName" name="condPatName" v-model="condPatName" disabled>
                            <input type="text" class="form-control form-control-sm" style="background-color:Linen;" ref="condPatLName" name="condPatLName" v-model="condPatLName" disabled>
                            <button type="button" id="btnFindPat" class="btn btn-danger ms-1" title="เคลียร์คนไข้ที่เลือก" @click="resetCondSearchPat()">X</button>
                            <button type="button" id="btnFindPat" class="btn btn-secondary " data-bs-toggle="modal" data-bs-target="#findPatientModal" >ค้นหา..</button>
                        </div>
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                        <!-- คลินิก -->
                        <div class="input-group input-group-sm mb-1">
                            <div class="input-group-prepend">
                            <span class="input-group-text" style="width:120px;">คลินิก * :</span>
                            </div>
                            <select class="form-select form-select-sm" ref="ReqClinicID" name="ReqClinicID" v-model="condReqClinicID">
                                <option disabled value="">Please select one</option>
                                <option v-for="item in dataCliniclists" :key="item.ReqClinicID" :value="item.ReqClinicID">{{ item.ReqClinicName }}</option>
                            </select>
                            <button type="button" id="btnFindPat" class="btn btn-danger" title="เคลียร์คลินิกที่เลือก" @click="resetCondSearchReqClinic()">X</button>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="row my-2">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
                <LabPrint1View :datalists="datalists" :key="countRefresh"
                    :nameIdx="nameIdx"
                    :nameTestsuitIdx="nameTestsuitIdx"
                    :optResultedOnly="optResultedOnly"
                    :optDOB="optDOB"
                    :optWatermark="optWatermark"
                    :optOneTestsuitPerPaper="optOneTestsuitPerPaper"
                    :optHLineTable="optHLineTable"
                    :optRoomSplit="optRoomSplit"
                    :optTSSplit="optTSSplit"
                    :optRoomShow="optRoomShow"
                    :arrBoldResults="['positive','positived','l','h','detected','detect','found','r']"
                    :dataCliniclists="dataCliniclists"
                    @onViewResultEvent="viewResultPage"></LabPrint1View>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 my-div-p0 card" style="background-color:PaleGreen">
                <LabPrint2Dtl :key="countDtlRefresh"
                  :dataROHead="curRecord"
                  @onBackPageAfterSaveEvent="backPageAfterSave"></LabPrint2Dtl>
              </div>
            </div>
        </div>
    </div>

<!-- Modal แสดงหน้าต่างค้นหารายชื่อคนไข้ -->
<div id="findPatientModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-xl">
    <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title">ค้นหาคนไข้จากทะเบียนประวัติ</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <modelFindPatient @onBackPageAfterSelectPatientEvent="backPageAfterSelectPatient"></modelFindPatient>
            <!-- <div class="row bg-light mb-2">
              <div class="col-2"></div>
              <div class="col">
                <div class="input-group input-group-sm mb-1" title="ป้อนคำเพื่อค้นหาจากชื่อ นามสกุลและเลขบัตรประชาชน / Passport No.">
                    <div class="input-group-prepend">
                    <span class="input-group-text fs-3" style="width:140px;">คำค้นหา :</span>
                    </div>
                    <input type="text" class="form-control form-control-sm fs-3 fw-bold" placeholder="ป้อนคำค้นหา"
                      name="findTextPatient" v-model="findTextPatient" v-on:keyup.enter="findPatients()">
                    <button class="btn bg-transparent" style="margin-left: -40px; z-index: 100;" @click="findTextPatient=''">
                        <i class="fa fa-times"></i>
                    </button>
                    <button type="button" class="btn btn-info fs-3 mx-1" style="width:100px;" @click="findPatients()">ค้นหา</button>
                </div>
              </div>
              <div class="col-2"></div>
            </div>
            <table id="myFindPatientTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th>คำนำหน้า</th>
                    <th>ชื่อ</th>
                    <th>นามสกุล</th>
                    <th>เลขบัตรปชช.</th>
                    <th>จังหวัด</th>
                    <th>ประเทศ / พาสปอร์ต</th>
                    <th>คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in dataPatientFindlists" :key="item.PatID">
                    <td class="text-start">{{ item.PrefixName }}</td>
                    <td class="text-start">{{ item.PatName }}</td>
                    <td class="text-start">{{ item.PatLName }}</td>
                    <td class="text-start">{{ item.IDNo }}</td>
                    <td class="text-start">{{ item.Province }}</td>
                    <td class="text-start">{{ item.Country }} / {{ item.PassportNo }}</td>
                    <td  >
                        <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"
                          id="add" @click="selectPatient(item)">เลือก</button>
                    </td>
                </tr>
                </tbody>
            </table> -->
        </div>

        <div class="modal-footer">
          <div class="container">
            <button type="button" class="btn btn-secondary pull-right" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import LabPrint1View from './LabPrint1View.vue'
import LabPrint2Dtl from './LabPrint2Dtl.vue'
import modelFindPatient from './modelFindPatient.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabPrint',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      condPrintOption: true,
      condSearchPatient: false,
      condPatID: 0, // กรองตามคนไข้ด้วย (ถ้าระบุ)
      condPatName: '',
      condPatLName: '',
      condReqClinicID: 0, // กรองตามคลินิกส่งตรวจด้วย (ถ้าระบุ)
      // status0New: false,
      // status1Lab: false,
      status1Lab: true,
      status2Res: false,
      status3App: true,
      nameIdx: 1, // ชื่อคนไข้ที่พิมพ์ : 0-ใช้ชื่อแรก 1-ใช้ชื่อที่สอง
      nameTestsuitIdx: 0, // ชื่อชุดตรวจที่พิมพ์ : 0-ใช้ชื่อหลัก 1-ใช้ชื่อที่สอง
      // 0-พิมพ์ทั้งหมด หรือ 1-พิมพ์ผลแล็บเฉพาะที่ป้อนผลแล้ว
      optResultedOnly: false,
      optDOB: false,
      optWatermark: false,
      optOneTestsuitPerPaper: false,
      optHLineTable: false,
      optRoomSplit: false,
      optTSSplit: false,
      optRoomShow: false,

      countRefresh: 0,
      countDtlRefresh: 0,
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
      dataCliniclists: null
    }
  },
  created () {
    // Initial Value
    this.getOfficerData()
    this.getBranchData()
    this.getClinicData()
  },
  mounted () {
    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    LabPrint1View, LabPrint2Dtl, modelFindPatient
  },
  watch: {
    condPatID: 'getData'
  },
  methods: {
    // เคลียร์ตัวกรองที่ระบุ
    resetCondSearchPat () {
      this.condPatID = 0
      this.condPatName = ''
      this.condPatLName = ''
    },
    resetCondSearchReqClinic () {
      this.condReqClinicID = 0
    },
    resetCondSearch () {
      this.resetCondSearchPat()
      this.resetCondSearchReqClinic()
    },
    // เลือกดึงข้อมูลใบสั่งตรวจเฉพาะของคนไข้ที่ระบุ
    backPageAfterSelectPatient (row) {
      this.condPatID = row.PatID
      this.condPatName = row.PatName
      this.condPatLName = row.PatLName
    },
    backPageAfterSave () {
      this.$nextTick(() => {
        $('#myLabPrintTable').DataTable()
      })
      // Refresh ตารางใบสั่งตรวจ สถานะเปลี่ยน
      this.getData()
      this.viewResultPage(null)
    },
    backPage () {
      this.$nextTick(() => {
        $('#myLabPrintTable').DataTable()
      })
    },
    // เปิดหน้าต่างแสดงผลแล็บ
    viewResultPage (row) {
      // console.log('callback to refresh!!!')
      this.curRecord = row
      this.countDtlRefresh++
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
    getClinicData () {
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataCliniclists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD
      var BranchID = this.branchID
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      MyApiClient.get('getdata/labrequest_where_print.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3 +
        '&PatID=' + this.condPatID + '&ReqClinicID=' + this.condReqClinicID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { this.$refs.myBranchTable.DataTable() }, 0)
          // console.log('on update ตาราง')
          setTimeout(function () { $('#myLabPrintTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>
.my-div-p0 {
  padding: 0px;
}
<style>

</style>
